import React, { useEffect, useState } from "react";
import { convertToDomId } from "../../Utils";
import { Grid } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { VpnKey } from "@mui/icons-material";
const styles = {
    filterContainer: { display: "inline" },
    iconActive: { fill: "var(--clr-secondary)" },
};
export var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "asc";
    SortDirection["DESC"] = "desc";
    SortDirection["NO"] = "no";
})(SortDirection || (SortDirection = {}));
export default function HeaderComponent(props) {
    let id = convertToDomId(props.column.colId);
    const [sort, setSort] = useState(SortDirection.NO);
    const onSortChanged = () => {
        if (props.column.isSortAscending()) {
            setSort(SortDirection.ASC);
        }
        else if (props.column.isSortDescending()) {
            setSort(SortDirection.DESC);
        }
        else {
            setSort(SortDirection.NO);
        }
    };
    const toggleSort = () => {
        if (sort == SortDirection.NO) {
            onSortRequested(SortDirection.ASC);
        }
        else if (sort == SortDirection.ASC) {
            onSortRequested(SortDirection.DESC);
        }
        else {
            onSortRequested(SortDirection.NO);
        }
    };
    const onSortRequested = (order) => {
        props.setSort(order);
    };
    useEffect(() => {
        props.column.addEventListener("sortChanged", onSortChanged);
        onSortChanged();
    }, []);
    let iconCount = 1 + Number(props.isPrimaryKey);
    let iconWidth = iconCount * 15;
    return (React.createElement(Grid, { container: true, direction: "row", alignContent: "center", justifyContent: "space-between", wrap: "nowrap" },
        React.createElement(Grid, { item: true, sx: { marginTop: "4%" } },
            React.createElement("span", { style: { color: "var(--clr-primary)" }, title: props.displayName }, props.displayName)),
        React.createElement(Grid, { item: true },
            props.isPrimaryKey ? React.createElement(VpnKey, { style: { marginLeft: "7px" } }) : React.createElement(React.Fragment, null),
            React.createElement("div", { onClick: toggleSort, style: { display: "inline" } },
                React.createElement(ArrowRightAltIcon, { style: { transform: "rotate(90deg)" }, sx: sort == SortDirection.ASC ? { fill: "var(--clr-secondary)" } : {} }),
                React.createElement(ArrowRightAltIcon, { style: { transform: "rotate(-90deg)", marginLeft: "-15px" }, sx: sort == SortDirection.DESC ? { fill: "var(--clr-secondary)" } : {} })))));
}
